import pkg from 'lodash';

const { debounce: lodashDebounce } = pkg;

export const debounce = (functionInstance: any, ms = 1500) => lodashDebounce(functionInstance, ms);
